// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete, createOrUpdate, get, list } from "./operations.js";
export {
  DatastoresDeleteOptionalParams,
  DatastoresCreateOrUpdateOptionalParams,
  DatastoresGetOptionalParams,
  DatastoresListOptionalParams,
} from "./options.js";
